module.exports = __webpack_public_path__ + "img/advantagesImg1.f5254bd7.jpg";